export default __webpack_public_path__ + "static/media/logo.54f80fc5.png";